"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

interface SettingsTabLoaderProps {
  message?: string;
}

/**
 * Unified loading state for voice agent settings tabs.
 * Shows a consistent loader until all data is ready.
 */
export function SettingsTabLoader({ message = "Loading settings..." }: SettingsTabLoaderProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="py-12">
          <div className="flex flex-col items-center justify-center gap-3">
            <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
            <p className="text-sm text-muted-foreground">{message}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
